/**
 * @file Main Footer component - sitewide.
 */

import React from 'react';

import { getAsset } from '../../util/assets';
import getConfig from '../../util/config';
import XIcon from '../icons/XIcon';

const Footer = () => {
  const config = getConfig();

  return (
    <footer className="footer-main">
      <div className="footer-nav-links">
        <a className="d-none d-md-inline-block" href="/contact">
          Contact Us
        </a>

        <a className="d-none d-md-inline-block" href="/company">
          Company
        </a>

        <a
          className="d-none d-md-inline-block"
          href={`${config.marcomUrl}/blog`}
          target="_blank"
          rel="noopener noreferrer"
        >
          Blog
        </a>

        <a href="/terms">Terms of Use</a>

        <a href="/terms/pro">Pro Terms of Use</a>
      </div>

      <span className="footer-socials">
        <a
          className="icon-social"
          href="https://www.facebook.com/waldophotos"
          target="_blank"
          rel="noreferrer noopener"
        >
          <img src={getAsset('/icon-facebook.svg')} alt="Waldo on Facebook" />
        </a>

        <a
          className="icon-social"
          href="https://twitter.com/waldophotos"
          target="_blank"
          rel="noreferrer noopener"
        >
          <XIcon color="#FFFFFF" size={20} />
        </a>

        <a
          className="icon-social"
          href="https://www.instagram.com/waldophotos"
          target="_blank"
          rel="noreferrer noopener"
        >
          <img src={getAsset('/icon-instagram.svg')} alt="Waldo on Instagram" />
        </a>
      </span>

      <span className="footer-copyright">
        &copy; Waldo {config.date.currentYear}
        <span className="d-none d-lg-inline-block">, All rights reserved</span>
      </span>
    </footer>
  );
};

export default Footer;
